import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const ExportAction = styled(Box)`
  display: flex;
  align-items: center;
  gap: 16px;
`

export const ValuesLabel = styled(Box)`
  ${({ theme }) => css`
    font-size: 14px;
    font-weight: 700;
    color: ${theme.colors.secondary};
    white-space: nowrap;
  `}
`
